export const CLAYPOND_COMPANIES = [
  {
    id: "akasa-air",
    name: "Akasa Air",
    sector: "Aviation",
    headcount: 5000,
    asbc_gap: 180000000,
    labour_cost: 650000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/akasa-air-claypond-2026",
    signal: "red",
    urgency_reason: "Rapid scaling creating workforce architecture gaps",
    functions: ["Flight Operations", "Ground Services", "Engineering", "Commercial", "Digital & IT", "HR & People"],
    competitors: [
      { name: "Akasa Air", score: 28, isTarget: true },
      { name: "IndiGo", score: 72 },
      { name: "Air India", score: 48 },
      { name: "SpiceJet", score: 38 },
      { name: "Vistara", score: 62 },
    ],
    velocity_headline: "Scaling at pace but workforce design lagging IndiGo benchmark",
    leadership_scores: [5, 4, 7, 5, 3, 5, 5],
    readiness_score: 71,
    readiness_drivers: [
      "Hyper-growth phase creating org design debt",
      "Succession depth at 3/10 is critically low for a scaling airline",
      "Ground services and flight ops functions need redesign",
    ],
  },
  {
    id: "zepto",
    name: "Zepto",
    sector: "Quick Commerce",
    headcount: 8000,
    asbc_gap: 240000000,
    labour_cost: 850000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/zepto-claypond-2026",
    signal: "red",
    urgency_reason: "Last-mile ops at high automation risk",
    functions: ["Dark Store Operations", "Last-Mile Delivery", "Technology", "Category Management", "Finance", "HR & People"],
    competitors: [
      { name: "Zepto", score: 44, isTarget: true },
      { name: "Blinkit", score: 72 },
      { name: "Swiggy Instamart", score: 68 },
      { name: "BigBasket", score: 56 },
      { name: "JioMart", score: 51 },
    ],
    velocity_headline: "Last-mile automation 1.6\u00d7 behind Blinkit",
    leadership_scores: [6, 4, 8, 6, 4, 6, 5],
    readiness_score: 65,
    readiness_drivers: [
      "8,000 workforce heavily concentrated in operations roles",
      "Last-mile delivery at highest automation inflection point",
      "Strong external hire ratio but low tenure stability",
    ],
  },
  {
    id: "healthifyme",
    name: "HealthifyMe",
    sector: "Health Technology",
    headcount: 1800,
    asbc_gap: 72000000,
    labour_cost: 280000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/healthifyme-claypond-2026",
    signal: "amber",
    urgency_reason: "AI coaching capability lagging product ambition",
    functions: ["Technology & AI", "Nutrition Services", "Product", "Growth & Marketing", "Finance", "HR & People"],
    competitors: [
      { name: "HealthifyMe", score: 48, isTarget: true },
      { name: "Cult.fit", score: 62 },
      { name: "GOQii", score: 44 },
      { name: "Noom", score: 78 },
      { name: "MyFitnessPal", score: 72 },
    ],
    velocity_headline: "AI coaching capability lagging global health-tech peers",
    leadership_scores: [6, 5, 6, 6, 4, 6, 5],
    readiness_score: 56,
    readiness_drivers: [
      "Nutrition services workforce is primary BOT candidate",
      "Product ambition outpacing AI coaching capability build",
      "Global peers already deploying AI-first coaching models",
    ],
  },
  {
    id: "pharmeasy",
    name: "PharmEasy",
    sector: "Digital Pharmacy",
    headcount: 4500,
    asbc_gap: 135000000,
    labour_cost: 520000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/pharmeasy-claypond-2026",
    signal: "red",
    urgency_reason: "Logistics and ops workforce cost above sector median",
    functions: ["Logistics & Fulfilment", "Technology", "Pharmacy Operations", "Commercial", "Finance", "HR & People"],
    competitors: [
      { name: "PharmEasy", score: 34, isTarget: true },
      { name: "Tata 1mg", score: 62 },
      { name: "Apollo 24|7", score: 58 },
      { name: "Netmeds", score: 44 },
      { name: "MedLife", score: 48 },
    ],
    velocity_headline: "Logistics cost structure 22% above sector median",
    leadership_scores: [5, 5, 5, 5, 4, 5, 4],
    readiness_score: 68,
    readiness_drivers: [
      "Logistics and fulfilment workforce at highest automation potential",
      "Pharmacy ops function over-resourced vs digital-first peers",
      "Cash burn pressure makes transformation urgent",
    ],
  },
  {
    id: "easy-home",
    name: "Easy Home Finance",
    sector: "Fintech Lending",
    headcount: 1200,
    asbc_gap: 48000000,
    labour_cost: 190000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/easyhome-claypond-2026",
    signal: "amber",
    urgency_reason: "Field force structuring opportunity identified",
    functions: ["Field Sales & Collections", "Credit & Underwriting", "Technology", "Operations", "Finance", "HR & People"],
    competitors: [
      { name: "Easy Home Finance", score: 40, isTarget: true },
      { name: "Aavas Financiers", score: 58 },
      { name: "Aptus Value Housing", score: 54 },
      { name: "Home First Finance", score: 62 },
      { name: "PNB Housing", score: 48 },
    ],
    velocity_headline: "Field force structuring 1.4\u00d7 behind housing finance peers",
    leadership_scores: [5, 6, 5, 4, 5, 5, 6],
    readiness_score: 52,
    readiness_drivers: [
      "Field force of 800+ at digitisation inflection point",
      "Credit underwriting tasks highly automatable",
      "Small scale enables rapid transformation pilot",
    ],
  },
];
